<template>
  <div class="gv-overlay-sample">
    <div class="gv-overlay-sample__stage">
      <img v-if="source" :key="replayKey + source + animation" :src="source" :class="animation" :style="imageStyle" :alt="kind === 'sound' ? 'Saved mute illustration preview' : 'Saved play button preview'" />
      <span v-else :key="replayKey + animation" class="gv-overlay-sample__default" :class="[animation, theme]" :style="{ background: primary }">▶</span>
    </div>
    <button type="button" @click="replayKey++">Replay animation</button>
  </div>
</template>
<script>
import 'animate.css';
import { playSource, soundSource, playSize, soundSize, animationClass } from './overlayPreview';
export default {
  name: 'LegacyOverlayPreview',
  props: { model: { type: Object, required: true }, kind: { type: String, default: 'play' } },
  data: () => ({ replayKey: 0 }),
  computed: {
    source() { return this.kind === 'sound' ? soundSource(this.model) : playSource(this.model); },
    animation() { return animationClass(this.kind === 'sound' ? this.model.settings.unmute_animation : this.model.play_button.animation); },
    imageStyle() { return { height: (this.kind === 'sound' ? soundSize(this.model.settings.unmute_size) : playSize(this.model.play_button.size)) + 'px' }; },
    primary() { return this.model.settings.color?.primary || '#FD6481'; },
    theme() { return this.model.settings.theme || 'vjs-theme-default'; },
  },
};
</script>
<style scoped>
.gv-overlay-sample { display: flex; align-items: center; gap: 16px; background: #202333; border-radius: 8px; padding: 20px; }
.gv-overlay-sample__stage { display: flex; align-items: center; justify-content: center; flex: 1; min-width: 0; min-height: 152px; }
.gv-overlay-sample img { max-width: 100%; object-fit: contain; }
.gv-overlay-sample__default { display: flex; align-items: center; justify-content: center; width: 80px; height: 80px; color: #fff; font-size: 32px; border-radius: 50%; }
.gv-overlay-sample__default.vjs-theme-youtube, .gv-overlay-sample__default.vjs-theme-vimeo { width: 96px; height: 60px; border-radius: 12px; }
.gv-overlay-sample__default.vjs-theme-wistia { border-radius: 0; }
.gv-overlay-sample button { background: transparent; border: 0; color: white; cursor: pointer; text-decoration: underline; font-size: 12px; }
@media(prefers-reduced-motion:reduce) { .animate__animated { animation: none !important; } }
</style>
